import React, {Component} from 'react';
import {Bar} from 'react-chartjs-2';
import * as helpers from '../lib/helpers';
import Legend from '../components/Legend';
import { LanguageContext, LanguageConsumer } from '../lib/LanguageContext'
import './SubChart.css'

const errorAnalysisMax  = 10;

class SubChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorData: {
                labels: [],
                legendLabels: [],
                datasets: [],
            }
        }
    }

    changeChartData = (chartData) => {
        let colorsUsed = [];
        let labels = [];
        if(chartData) {
            let counts = chartData.map(err => err.count);
            let normalizedCounts = helpers.normalizeToRange(counts, 1, errorAnalysisMax);
            let newErrorData = {
                ...this.state.errorData,
                datasets: [
                    ...chartData.filter(err => this.context.polyglot.has(`errors.${err.errorCode}`))
                                .map((err, i) => {
                            let color = helpers.generateRandomColor(colorsUsed);
                            colorsUsed.push(color);
                            let perc = helpers.truncateFloat(err.percentage);
                            let label = `${this.context.polyglot.t(`errors.${err.errorCode}`)} [${err.errorCode}] : ${err.count} `;
                            labels.push(label);
                            return {
                                label,
                                data: [normalizedCounts[i]],
                                backgroundColor: color,
                                originalData: [err.count],
                                percentage: perc
                            }
                    })
                ],
                legendLabels: labels,
            }
            this.setState(prevState => ({
                ...prevState,
                errorData: newErrorData
            }))
        }
        else {
            this.setState(prevState => ({
                ...prevState,
                errorData: {
                    labels: [],
                    legendLabels: [],
                    datasets: [],
                }
            }))
        }
    }

    handleSelectChange = (e) => {
        let chosenClass = e.target.value;
        this.props.handleChange(chosenClass);
    }

    closeModal = () => {
        this.props.closeModal()
    }

    async updateComponent() {
        if(this.props.content.chartData) {
            this.changeChartData(this.props.content.chartData)
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.content.id !== this.props.content.id) {
            this.updateComponent();
        }
    }

    componentWillMount() {
        this.updateComponent();
    }

    render() {
        return(
          <LanguageConsumer>
            {({polyglot}) =>
            (<div className='subChart'>
                <div className="modalSelect">
                    <div className="select">
                        <span className="select-icon">
                            <Legend-color style={{backgroundColor: this.props.content.labelColor}}></Legend-color>
                        </span>
                        <select value={this.props.content.id} onChange={this.handleSelectChange}>
                            {
                                this.props.content.allData.map(cl => 
                                <option key={cl[this.props.content.idName]} value={cl[this.props.content.idName]}>
                                     {polyglot.t(`${this.props.content.polyglotId}.${cl[this.props.content.idName]}`)}
                                </option>)
                            }
                        </select>
                    </div>
                        <div className="closeModal" onClick={this.closeModal}>
                            <div id='x-icon'>
                                <span />
                                <span />
                                <span />
                                <span />
                            </div>
                        </div>
                    </div>
                    <div id='content-container' className={this.props.modalTransition}>
                        <div id='subChart-header'>
                            {`${polyglot.t(`${this.props.content.idName}Header`)} :`}
                        </div>
                        <div className='subchart-container'>
                        <Bar
                            ref={this.props.content.chartRef}
                            data={this.state.errorData} width={10}
                            options={{
                                maintainAspectRatio: false, 
                                legend: {
                                    position: 'left',
                                    display: false,
                                    fullWidth: true
                                },
                                scales: {
                                    yAxes: [{
                                        barPercentage: 0.5,
                                        ticks: {
                                            beginAtZero: true,
                                            max: errorAnalysisMax
                                        }
                                    }]
                                },
                                tooltips: {
                                    mode: 'nearest',
                                    callbacks: {
                                        label: (tooltipItem, data) => {
                                            let newLabel = '';
                                            let item = this.state.errorData.datasets[tooltipItem.datasetIndex];
                                            let oldLabel = `${item.label} (${item.percentage}%)`;
                                            oldLabel = oldLabel.split(" ").filter(word => word.length > 0).slice(0, 5)
                                            oldLabel.map((word, i) => 
                                                (newLabel += `${word} `)
                                            )
                                            return newLabel;
                                        },
                                        afterLabel: (tooltipItem, data) => {
                                            let multiLineLabel = [];
                                            let tempStr = '';
                                            let item = this.state.errorData.datasets[tooltipItem.datasetIndex];
                                            let newLabel = `${item.label} (${item.percentage}%)`
                                            let restLabel = newLabel.split(" ").filter(word => word.length > 0).slice(5);
                                            restLabel.map((word, i) => {
                                                tempStr += `${word} `;
                                                if((i+1)%5 === 0 || restLabel.length-i === 1) {
                                                    multiLineLabel.push(tempStr)
                                                    tempStr = '';
                                                }
                                                return 0;
                                            })
                                            return multiLineLabel;
                                        }
                                    }
                                }
                            }}
                        /> 
                         </div>
                        <Legend id={"subchart-legend"} data={this.state.errorData} openTip={this.props.openTip} closeTip={this.props.closeTip} typeOfChart='Bar' chartRef={this.props.content.chartRef}/>
                    </div>
                </div>)}
            </LanguageConsumer>
        );
    }
}
SubChart.contextType = LanguageContext

export default SubChart;



// WEBPACK FOOTER //
// ./src/overview/SubChart.js